import {action, makeObservable, observable, runInAction} from "mobx";
import {requests} from "../api";
import {UserRequest} from "../models/user";

export default class UserStore {
    @observable loading = false
    @observable error = ""
    @observable userData: {[id: string]: UserRequest } = {}

    constructor() {
        makeObservable(this)
    }

    @action
    loadDetails(id: string) {
        if (this.loading) return
        this.loading = true

        requests.get('/manage/user/' + id)
            .then(data => {
                runInAction(() => {
                    this.userData[id] = new UserRequest(data)
                })
            })
            .catch(err => runInAction(() => this.error = `error: ${err}`))
            .finally(() => runInAction(() => this.loading = false))
    }
}
